(() => {
  let pending = false;
  const sorted = new WeakSet();
  const isGerman = location.hostname.endsWith('.de') || (!location.hostname.endsWith('.nl') && document.documentElement.lang.startsWith('de'));
  const reviewProducts = [
    {nl:'Waar Liefde Woont', de:'Wo die Liebe wohnt', aliases:['Amsterdam 2026']},
    {nl:'Een Hart Vol Winter', de:'Ein Herz voller Winter', aliases:['cozy heart']},
    {nl:'Het Mooiste Geschenk', de:'Das schönste Geschenk', aliases:['Cozy Story — Giftbox Square','Giftbox Square','Giftbox']},
    {nl:'Ons Kleine Geluk', de:'Unser kleines Glück', aliases:['living room','Livingroom Round']}
  ];
  function updateReviewProductNames() {
    document.querySelectorAll('#MainContent .jm-product-variant-card').forEach(card => {
      const link = card.querySelector('.jm-product-variant-card__product-link');
      if (!link) return;
      const current = link.textContent.trim().toLocaleLowerCase();
      const product = reviewProducts.find(p => [p.nl, p.de, ...p.aliases].some(name => name.toLocaleLowerCase() === current));
      if (!product) return;
      const name = isGerman ? product.de : product.nl;
      if (link.textContent !== name) link.textContent = name;
      card.querySelectorAll('[role="button"]').forEach(button => {
        const label = isGerman ? `${name} ansehen` : `Bekijk ${name}`;
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      });
      card.querySelectorAll('img').forEach(img => { if (img.alt !== name) img.alt = name; });
    });
  }
  function update() {
    pending = false;
    updateReviewProductNames();
    const title = document.documentElement.lang.startsWith('de') ? 'Was unsere Kunden erzählen' : 'Wat onze klanten vertellen';
    document.querySelectorAll('#MainContent .jm-review-widget-minimal-header__title, #MainContent .jm-review-widget-header__title').forEach(heading => {
      if (heading.textContent !== title) heading.textContent = title;
    });
    document.querySelectorAll('#MainContent .jm-review-widget .jm-sort-filter__select').forEach(select => {
      if (sorted.has(select) || !select.querySelector('option[value="pictures_first"]')) return;
      sorted.add(select);
      if (select.value !== 'pictures_first') {
        select.value = 'pictures_first';
        select.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
    document.querySelectorAll('.ct-product-page__review-summary .ct-review-stars__base, .ct-product-page__review-summary .ct-review-stars__fill').forEach(stars => {
      const glyphs = (stars.classList.contains('ct-review-stars__base') ? '\uE001' : '\uE000').repeat(5);
      if (stars.textContent !== glyphs) stars.textContent = glyphs;
    });
    document.querySelectorAll('#MainContent .jm-review-widget .jm-average-rating-display').forEach(header => {
      const row = header.querySelector('.jm-cluster');
      if (!row) return;
      const texts = [...row.children].filter(el => el.tagName === 'P');
      if (texts.length < 2) return;
      const score = Number.parseFloat(texts[0].textContent.replace(',', '.'));
      const count = texts[1].textContent.match(/[\d.,\s]+/)?.[0].trim();
      if (count) texts[1].dataset.csReviewCount = `(${count})`;
      if (!Number.isFinite(score)) return;
      let stars = row.querySelector('.cs-widget-stars');
      if (!stars) {
        stars = document.createElement('span');
        stars.className = 'cs-widget-stars';
        stars.textContent = '\uE001'.repeat(5);
        stars.setAttribute('role', 'img');
        row.prepend(stars);
      }
      stars.style.setProperty('--cs-rating-fill', `${Math.max(0, Math.min(5, score)) * 20}%`);
      stars.setAttribute('aria-label', `${score} / 5`);
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  new MutationObserver(schedule).observe(document.documentElement, {childList:true,characterData:true,subtree:true});
  schedule();
})();

// A photo-only dialog, independent of Judge.me's review-details modal.
(() => {
  let dialog, photo, opener, previousOverflow;
  function openPhoto(trigger) {
    const thumbnail = trigger.querySelector('img');
    if (!thumbnail || trigger.querySelector('video') || trigger.querySelector('[class*="play"]')) return false;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'cs-review-photo-dialog';
      dialog.setAttribute('aria-label', document.documentElement.lang.startsWith('de') ? 'Bewertungsfoto' : 'Reviewfoto');
      const close = document.createElement('button');
      close.type = 'button'; close.className = 'cs-review-photo-close'; close.textContent = '×';
      close.setAttribute('aria-label', document.documentElement.lang.startsWith('de') ? 'Schließen' : 'Sluiten');
      photo = document.createElement('img');
      dialog.append(close, photo); document.body.append(dialog);
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        photo.removeAttribute('src');
        opener?.focus({preventScroll:true});
      });
    }
    const source = new URL(thumbnail.currentSrc || thumbnail.src, location.href);
    source.searchParams.set('width', '1800'); source.searchParams.set('quality', '90');
    photo.src = source.href; photo.alt = thumbnail.alt || 'Reviewfoto';
    opener = trigger; previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden'; dialog.showModal();
    return true;
  }
  function handle(event) {
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    const trigger = event.target.closest?.('#MainContent .jm-review-item .jm-media-thumbnail-list__thumbnail');
    if (!trigger || dialog?.open) return;
    if (openPhoto(trigger)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }
  document.addEventListener('click', handle, true);
  document.addEventListener('keydown', handle, true);
})();
